<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">House System</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Academics</a></span>
                                        </div>
                                        <span>House System</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->



        <!-- class area start here -->
        <section class="bd-class-area pt-10 pb-70">
            <div class="container">
                <div class="row">
                    <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp mt-100" data-wow-duration="1s"
                        data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 1s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <h2 class="bd-section-title mb-0">House System</h2>
                        <p style="margin: 0px;">At Vedanta Gurukul Public School, a proud initiative of Vedanta
                            Foundation, our House System fosters a strong sense of fellowship among students.</p>
                        <p style="margin: 0px;">Through participation in sports and co-curricular activities both within
                            and outside the school, students experience a holistic development. </p>
                        <p style="margin: 0px;">This system not only nurtures a healthy competitive spirit but also
                            teaches
                            teamwork, boosts self-confidence, develops leadership skills, and instills essential moral
                            and
                            social values. Each student is allocated to one of the four houses, contributing to a
                            vibrant and enriching school experience.</p>

                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/houses/JAINTIA HOUSE.jpeg" alt="class image not found!">
                            </div>
                            <div class="theme-bg-6 ">
                                <h3 class="text-center" style="margin: 0;padding:10px;"><a href="#">Jodha House</a>
                                </h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 35px;color:white;padding: 5px;">
                                <ul>
                                    <li><b>Captain: </b>Paridhi Pareek</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/houses/HIMALAYA HOUSE.jpeg" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6 ">
                                <h3 class="text-center" style="margin: 0;padding:10px;"><a href="#">Pratap House</a>
                                </h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 35px;color:white;padding: 5px;">
                                <ul>
                                    <li><b>Captain: </b>Komal Kumawat</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/houses/ARAWALI HOUSE.jpeg" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;"><a href="#">Uday House</a>
                                </h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 35px;color:white;padding: 5px;">
                                <ul>
                                    <li><b>Captain: </b>Mahak Sharma</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class=" fix radius-24 p-relative mb-50 wow fadeInUp" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-class-thumb">
                                <img src="/img/houses/SHIVALIK HOUSE.jpeg" alt="class image not found!">
                            </div>
                            <div class=" theme-bg-6">
                                <h3 class="text-center" style="margin: 0;padding:10px;"><a href="#">Jay House</a>
                                </h3>
                            </div>
                            <div class="theme-bg-2 text-center" style="height: 35px;color:white;padding: 5px;">
                                <ul>
                                    <li><b>Captain: </b>Aayush Vaishnav</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- class area end here -->


        <!-- promotion area start here  -->
        <section class="bd-promotion-area pt-120 pb-60 fix d-none">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-promotion bd-promotion-2 mb-60 wow fadeInLeft" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-section-title-wrapper mb-35">
                                <h2 class="bd-section-title mb-10">Study and Sports @ VGPS Campus</h2>
                                <!-- <span class="mb-10 d-inline-block">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                           </span>
                           <p>Quisque vehicula volutpat tellus at pulvinar. Mauris in fringilla odio, a sollicitudin elit. Proin tristique eleifend ex, et maximus nunc tempor vel. 
                           </p> -->
                            </div>
                            <div class="bd-promotion-list-2">
                                <ul>
                                    <li style="width: 40%;">
                                        <div class="bd-promotion-icon">
                                            <i class="flaticon-reading theme-bg-2"></i>
                                        </div>
                                        <span>Studies</span>
                                    </li>
                                    <li>
                                        <div class="bd-promotion-icon">
                                            <i class="flaticon-sports theme-bg"></i>
                                        </div>
                                        <span>Sports</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6">
                        <div class="bd-promotion-thumb-wrapper mb-60 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-promotion-thumb">
                                <div class="bd-promotion-thumb-mask p-relative">
                                    <img src="/img/campus/bottom_img.png" alt="Image not found">
                                    <div class="panel-2 wow"></div>
                                </div>
                            </div>
                            <div class="bd-promotion-shape d-none d-lg-block">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- promotion area end here  -->

    </main>
</template>
<script>
export default {
    name: "HouseView",
};
</script>
